import * as React from 'react'

import { Loader2 } from 'lucide-react'

import { cn } from '@/lib/html/class-name'

interface CenteredLoaderProps {
  message?: string
  className?: string
  minHeight?: string
}

function CenteredLoader({
  message = 'Please wait a few seconds while we load your content...',
  minHeight = 'min-h-screen',
  className,
}: CenteredLoaderProps) {
  return (
    <div
      className={cn('flex flex-col items-center justify-center', minHeight, className)}
      data-testid="centered-loader"
    >
      <div className="flex flex-col items-center space-y-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        {message && <p className="text-sm text-center max-w-md">{message}</p>}
      </div>
    </div>
  )
}

export { CenteredLoader }
